import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import ClientLayout from "../../components/client/ClientLayout";
import RequireClientAdmin from "../../components/client/RequireClientAdmin";
import SyncStatusBanner from "../../components/client/SyncStatusBanner";
import { clientApi } from "../../api";
import { formatDateTimeAU } from "../../utils/formatDate";

export default function SyncAwarenessReport() {
  return (
    <ClientLayout>
      <RequireClientAdmin>
        <Inner />
      </RequireClientAdmin>
    </ClientLayout>
  );
}

function Inner() {
  const [days, setDays] = useState(30);
  const [rows, setRows] = useState([]);
  const [cache, setCache] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true); setError("");
    try {
      const d = await clientApi.getSyncAwareness(days);
      setRows(d.rows || []);
      setCache(d.cache || null);
    } catch (err) { setError(err.message); }
    setLoading(false);
  }, [days]);

  useEffect(() => { load(); }, [load]);

  const stale = rows.filter((r) => r.stale).length;
  const notInLocal = rows.filter((r) => !r.in_local_db).length;

  return (
    <>
      <div className="venues-page-header">
        <div>
          <h1>Sync Awareness</h1>
          <p className="page-subtitle">Members updated in S7000 outside the portal</p>
        </div>
      </div>

      <SyncStatusBanner cache={cache} />

      <div style={{ display: "flex", gap: "0.5rem", margin: "1rem 0" }}>
        {[7, 30, 60, 90].map((d) => (
          <button key={d} className={`btn btn-sm ${days === d ? "btn-primary" : "btn-outline"}`} onClick={() => setDays(d)}>Last {d} days</button>
        ))}
      </div>

      {error && <div className="toast toast-error" style={{ marginBottom: "1rem" }}>{error}</div>}

      <div className="stat-grid" style={{ marginBottom: "1.5rem" }}>
        <div className="stat-card">
          <span className="stat-label">Recently updated in S7000</span>
          <span className="stat-value">{rows.length}</span>
        </div>
        <div className="stat-card">
          <span className="stat-label">Ahead of local DB</span>
          <span className="stat-value" style={{ color: stale ? "var(--warning)" : undefined }}>{stale}</span>
          <span className="stat-sub">Edited outside the portal</span>
        </div>
        <div className="stat-card">
          <span className="stat-label">Not in local DB</span>
          <span className="stat-value">{notInLocal}</span>
          <span className="stat-sub">S7000-only members</span>
        </div>
      </div>

      {loading ? <div style={{ color: "var(--text-muted)" }}>Loading…</div> : rows.length ? (
        <div className="table-wrap">
          <table className="data-table">
            <thead><tr><th>Member #</th><th>Name</th><th>Email</th><th>S7000 updated</th><th>Local updated</th><th>Drift</th></tr></thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.membershipId} style={{ background: r.stale ? "var(--warning-bg, transparent)" : undefined }}>
                  <td><Link to={`/client/members/${r.membershipId}`}><code>#{r.membershipId}</code></Link></td>
                  <td>{r.firstname} {r.surname}</td>
                  <td style={{ fontSize: "0.85rem", color: "var(--text-muted)" }}>{r.email || "—"}</td>
                  <td style={{ fontSize: "0.85rem" }}>{fmt(r.s7000_updated)}</td>
                  <td style={{ fontSize: "0.85rem", color: r.in_local_db ? "var(--text)" : "var(--text-muted)" }}>
                    {r.in_local_db ? fmt(r.local_updated) : "not in local DB"}
                  </td>
                  <td>
                    {r.stale ? <span className="badge inactive">+{Math.round(r.drift_minutes)}m</span> : <span style={{ color: "var(--text-muted)" }}>—</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : <div className="empty-state"><h3>No recent updates</h3></div>}
    </>
  );
}

function fmt(v) {
  return formatDateTimeAU(v);
}
